import Tooltip from "@mui/material/Tooltip";
import { ComponentProps } from "../types";
import DashboardComponent from "./DashboardComponent";
import { Box } from "@mui/material";

function Component({ component }: ComponentProps) {
	return (
		<Tooltip key={component.id} title={component.properties["title"]}>
			<Box>{component.childern && component.childern.map((c, i) => <DashboardComponent key={i} component={c} />)}</Box>
		</Tooltip>
	);
}

export default Component;
